import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage';
import BookingPage from './BookingPage';
import Navbar from './Navbar';
import Footer from './Footer';
import PricingPage from './PricingPage';
import TermsPage from './TermsPage';

function App() {
  return (
    <Router>
      <div className="app-root">
        <Navbar />
        <main className="site-main">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/book" element={<BookingPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
